// extracted by mini-css-extract-plugin
export default {"wallet":"style_wallet__WoYQA","container":"style_container__4mu+M","hidden":"style_hidden__R8F6d"};